import React from 'react';
import styled from 'styled-components';
import {SIZES, Image, Typography} from '@fupa/fupa-uikit';

const Container = styled.div`
  display: flex;
  flex: 0 100%;
  height: ${SIZES['42']};
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  padding: ${SIZES['4']} ${SIZES['16']};
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: ${SIZES['12']};
`;

const Placeholder = styled.div`
  width: ${SIZES['32']};
  height: ${SIZES['32']};
`;

const StyledTypography = styled(Typography)`
  &&& {
    line-height: ${SIZES['16']};
  }
`;

const SuggestOption = ({result, ...props}) => {
  const subtitle = result?.club?.name ?? 'ohne Verein';

  const SearchImage = result.image ? (
    <Image circle entity={'player'} width={32} height={32} src={result.image} type='search' ratio='1:1' />
  ) : (
    <Placeholder />
  );

  const ClubImage = result.club ? (
    <Image entity='emblem' width={24} height={24} fit={true} src={result.club.image} type='search' ratio='1:1' />
  ) : null;

  return (
    <Container {...props}>
      {SearchImage}
      <InnerContainer>
        <Typography variant='body1'>{result.name}</Typography>
        <StyledTypography variant='caption1'>{subtitle}</StyledTypography>
      </InnerContainer>
      {ClubImage}
    </Container>
  );
};

export {SuggestOption};
